import { useTranslation } from 'react-i18next';

import { DataPanel } from '@/ui';
import type { Caller, PortalLocation } from '@/signalr';
import { CallerLocationBlock } from './CallerLocationBlock';

export type CallerLocationSectionProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  callerPosition: PortalLocation | null;
  callerPositionHistory: readonly PortalLocation[];
  caller: Caller;
  chatIsActive: boolean;
};

export function CallerLocationSection({
  incidentId,
  incidentIsReadOnly,
  callerPosition,
  callerPositionHistory,
  caller,
  chatIsActive,
}: CallerLocationSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_CallerLocationHeader')}>
      <CallerLocationBlock
        incidentId={incidentId}
        incidentIsReadOnly={incidentIsReadOnly}
        callerPosition={callerPosition}
        callerPositionHistory={callerPositionHistory}
        caller={caller}
        chatIsActive={chatIsActive}
      />
    </DataPanel>
  );
}
